export default __webpack_public_path__ + "static/media/polygon.9abc107c.png";